<template>
  <span :class="[`d2-${computedColorClass}`]">
    <slot></slot>
  </span>
</template>

<script>
// This helper colors an item string
export default {
  name: 'ItemString',
  props: {
    colorClass: String, // Overrides any manual calculations
    qualities: Array
  },
  computed: {
    computedColorClass () {
      if (this.colorClass) return this.colorClass

      const qualities = this.qualities.map(q => q.name)
      let classString = 'normal'

      // Order from lowest priority to highest
      const qualityPriority = [
        'Magic',
        'Rare',
        'Exceptional',
        'Elite',
        'Set',
        'Unique'
      ]

      for (const quality of qualityPriority) if (qualities.includes(quality)) classString = quality.toLowerCase()
      return `item-${classString}`
    }
  }
}
</script>
